import { boot } from 'quasar/wrappers'
import { VueQueryPlugin } from '@tanstack/vue-query'

// =============================================================================
// Vue Query
// =============================================================================
// import { Endpoints } from 'src/services/__vue_query__/endpoints'
// import { useBusinessQuery } from 'src/services/__vue_query__/api/fetchBusinessData'
// import { onMounted } from 'vue'
// onMounted(async () => {
//   const itemsQuery = useBusinessQuery(Endpoints.ITEMS_LIST, { filter: {} })
//   await itemsQuery.fetch()
// })
// =============================================================================

export default boot(({ app }) => {
  app.use(VueQueryPlugin)
})
